export default "__VITE_ASSET__COKAJUZo__"